import {
  hasInvoiceBackedBilling,
  isRevenueCatBilling,
  resolveIsCancelled
} from './subscription-display';
import ChangePlan from '../ChangePlan';
import FFHModal from '@components/modal';
import Button from '@components/atoms/button';
import { BodyRegular, H4 } from '@components/atoms/typography';
import Pill from '@components/atoms/Pill';
import { hasSufficientPrivileges } from '@lib/utils';
import { FFH_ROLES } from '@lib/constants';
import { getCurrencySymbol } from '@lib/page-utils/Join';

// A member with no membership role has never paid for one, so the row reads FREE
// rather than leaving the Type column blank.
const FREE_ROLE = 'FREE';

const SubscriptionRow = ({
  setIsChangePlanOpen,
  nextPaymentDate,
  nextPaymentAmount,
  subscriptionExpiresOn,
  isChangePlanOpen,
  userSubInfo,
  setIsCancelPlanOpen,
  initChurnkey,
  isCancelPlanOpen,
  stripeCustomerId,
  user,
  isCancelled,
  currencyCode,
  billingProvider
}) => {
  const hasPaidSubscription = hasSufficientPrivileges(user, 1);
  // Only Stripe members receive invoice data, so the date and price columns stay
  // empty for everyone else, as they did before the billing API migration.
  const hasReadableInvoice = hasInvoiceBackedBilling(billingProvider);
  const isSubscriptionCancelled = resolveIsCancelled({
    provider: billingProvider,
    claimStatus: userSubInfo?.status,
    invoiceIsCancelled: isCancelled
  });
  const hasRecurringSubscription = () => {
    if (isSubscriptionCancelled) return false;
    return userSubInfo && userSubInfo?.status === 'active';
  };
  const isAppSubscription = isRevenueCatBilling(billingProvider);
  const suscriptionCurrencyCode = currencyCode || 'gbp';
  return (
    <>
      <div className="membership-row grid grid-cols-2 md:grid-cols-4 p-1 gap-2">
        <div className="flex flex-col">
          <H4 className="pb-1">Type</H4>
          <BodyRegular className="capitalize">
            {user?.[FFH_ROLES]?.[0] ?? FREE_ROLE}
          </BodyRegular>
        </div>
        <div className="flex flex-col">
          <H4 className="pb-1">Status</H4>
          {isSubscriptionCancelled === undefined ? (
            <Pill value="Loading..." classNames="text-gray-500 bg-gray-100" />
          ) : isSubscriptionCancelled ? (
            <Pill
              value="Cancelled"
              classNames="text-danger-700 bg-danger-100"
            />
          ) : (
            <Pill value="Active" classNames="text-success-700 bg-success-100" />
          )}
        </div>
        <div className="flex flex-col">
          <H4 className="pb-1">
            {isSubscriptionCancelled ? 'Expires' : 'Renews'} on
          </H4>
          <BodyRegular>
            {hasReadableInvoice &&
              (isSubscriptionCancelled
                ? subscriptionExpiresOn
                : nextPaymentDate)}
          </BodyRegular>
        </div>
        <div className="flex flex-col">
          <H4 className="pb-1">Price</H4>
          <BodyRegular>
            {hasReadableInvoice && isSubscriptionCancelled ? '-' : ''}
            {hasReadableInvoice && nextPaymentAmount
              ? `${getCurrencySymbol(
                  suscriptionCurrencyCode
                )}${nextPaymentAmount}`
              : ''}
          </BodyRegular>
        </div>
      </div>
      <div className="flex mt-5">
        <Button variant="secondary" onClick={() => setIsChangePlanOpen(true)}>
          Manage Subscription
        </Button>
        <FFHModal
          open={isChangePlanOpen}
          handleClose={() => setIsChangePlanOpen(false)}
        >
          <ChangePlan
            isAppSubscription={isAppSubscription}
            nextPaymentDate={nextPaymentDate}
            nextPaymentAmount={nextPaymentAmount}
            setIsCancelPlanOpen={setIsCancelPlanOpen}
            initChurnkey={initChurnkey}
            isCancelPlanOpen={isCancelPlanOpen}
            isStripeMember={!!stripeCustomerId}
            hasPaidSubscription={hasPaidSubscription}
            hasRecurringSubscription={hasRecurringSubscription()}
            user={user}
          />
        </FFHModal>
      </div>
    </>
  );
};

export default SubscriptionRow;
